export default __webpack_public_path__ + "static/press-release-chatgpt-6968bfc5345840a5729be44e71724b00.jpg";